// Added by Sejune Oh on 2020-04-09
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import {
  DialogActions as MaterialUIDialogActions,
  DialogActionsProps as MaterialUIDialogActionsProps,
} from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface DialogActionsBaseProps {}
export type DialogActionsProps = MaterialUIDialogActionsProps & DialogActionsBaseProps

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const DialogActions:FC<DialogActionsProps> = ({...props}) => {
    return <MaterialUIDialogActions {...props} />
}
